import { InputNumberValueChangeParams } from 'primereact/inputnumber';
import React from 'react';
import { useId } from 'react-id-generator';
import BeeErrorLabel from './BeeErrorLabel';
import BeeInfoLabel from './BeeInfoLabel';
import BeeNumberInput from './BeeNumberInput';

import './BeeValidatedNumberInput.scss';

type BeeValidatedNumberInputProps = {
  label?: string;
  errorLabel?: string | null;
  neutralLabel?: string | null;
  validLabel?: string | null;
  value?: number;
  minFractionDigits?: number;
  maxFractionDigits?: number;
  disabled?: boolean;
  grouping?: boolean;
  formstate?: string;
  readOnly?: boolean;
  required?: boolean;
  onChange: (e: InputNumberValueChangeParams) => void;
  onFocusOut?: (e: React.FocusEvent<HTMLInputElement, Element>) => void;
};

export function BeeValidatedNumberInput({
  label,
  errorLabel,
  neutralLabel,
  validLabel,
  value,
  minFractionDigits,
  maxFractionDigits,
  disabled,
  grouping,
  formstate,
  readOnly,
  required,
  onChange,
  onFocusOut
}: BeeValidatedNumberInputProps) {
  const currentId = useId(1, 'bee-val-num-input-')[0];

  // classNames
  const labelClassNames = 'bee-validated-number-input';

  const textSize = 'medium';
  const inputFormstate = formstate === 'none' ? 'neutral' : formstate;

  function change(e: InputNumberValueChangeParams) {
    if (!disabled && onChange) {
      onChange(e);
    }
  }
  function focusOut(e: React.FocusEvent<HTMLInputElement, Element>) {
    if (!disabled && onFocusOut) {
      onFocusOut(e);
    }
  }

  const renderLabel = () => {
    return (
      <div className={labelClassNames}>
        {formstate === 'error' && errorLabel ? (
          <BeeErrorLabel size={textSize} label={errorLabel} visible={true} />
        ) : formstate === 'valid' && validLabel ? (
          <BeeInfoLabel
            size={textSize}
            label={validLabel}
            type={'valid'}
            visible={true}
          />
        ) : formstate === 'neutral' && neutralLabel ? (
          <BeeInfoLabel
            size={textSize}
            label={neutralLabel}
            type={'neutral'}
            visible={true}
          />
        ) : null}
      </div>
    );
  };

  return (
    <div id={currentId}>
      <BeeNumberInput
        label={label}
        value={value}
        minFractionDigits={minFractionDigits}
        maxFractionDigits={maxFractionDigits}
        disabled={disabled}
        grouping={grouping}
        formstate={inputFormstate}
        readOnly={readOnly}
        required={required}
        onChange={(e) => change(e)}
        onFocusOut={(e) => focusOut(e)}
      />
      {formstate !== 'none' && (errorLabel || neutralLabel || validLabel)
        ? renderLabel()
        : null}
    </div>
  );
}

export default BeeValidatedNumberInput;
